import React__default from 'react';

var MobileGameId = function (_a) {
    var id = _a.id, text = _a.text;
    return (React__default.createElement("div", { className: 'pgc-m-game-id-info' },
        React__default.createElement("p", { className: 'pgc-m-game-id-info-txt' }, text),
        React__default.createElement("p", { className: 'pgc-m-game-id-info-num' }, id)));
};

export { MobileGameId };
